import React from 'react';

export function CalendarSvg() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.78261 0V0.695652H0V16H15.3043V0.695652H12.5217V0H11.1304V0.695652H4.17391V0H2.78261ZM1.3913 2.08696H2.78261V2.78261H4.17391V2.08696H11.1304V2.78261H12.5217V2.08696H13.913V3.47826H1.3913V2.08696ZM1.3913 4.86957H13.913V14.6087H1.3913V4.86957ZM5.56522 6.26087V7.65217H6.95652V6.26087H5.56522ZM8.34783 6.26087V7.65217H9.73913V6.26087H8.34783ZM11.1304 6.26087V7.65217H12.5217V6.26087H11.1304ZM2.78261 9.04348V10.4348H4.17391V9.04348H2.78261ZM5.56522 9.04348V10.4348H6.95652V9.04348H5.56522ZM8.34783 9.04348V10.4348H9.73913V9.04348H8.34783ZM11.1304 9.04348V10.4348H12.5217V9.04348H11.1304ZM2.78261 11.8261V13.2174H4.17391V11.8261H2.78261ZM5.56522 11.8261V13.2174H6.95652V11.8261H5.56522ZM8.34783 11.8261V13.2174H9.73913V11.8261H8.34783Z"
        fill="#333333"
      />
    </svg>
  );
}
